import $ from "jquery";

class CalcRejuntes {

    constructor() {
        const btnorcamento = document.querySelector("#solicitarOrcamento");
        
        const btninformacao = document.querySelector("#solicitarInformacore");
        const closeinformation = document.querySelector(".close-box-information");
        const closeBginformation = document.querySelector(".modal-default .bg-information");

        const newsearch = document.querySelector("#fazerNovaConsulta");

        //Modal of Budget

        if (btnorcamento) {
            btnorcamento.addEventListener('click', function (event) {
                event.preventDefault();
                document.querySelector(".modal-orcamento").classList.add('show');
            });
        }


        //Modal of Information

        if (btninformacao) {
            btninformacao.addEventListener('click', function (event) {
                event.preventDefault();
                document.querySelector(".modal-informacoes").classList.add('show');
            });
        }

        if (closeinformation) {
            closeinformation.addEventListener('click', function (event) {
                event.preventDefault();
                document.querySelector(".modal-informacoes").classList.remove('show');
            });
        }

        if(closeBginformation){
            closeBginformation.addEventListener('click', function(event) {
                event.preventDefault();
                document.querySelector(".modal-informacoes").classList.remove('show');            
            });
        }

        if(newsearch){
            newsearch.addEventListener('click', function(event) {
                event.preventDefault();
                window.location.reload();         
            });
        }

        document.querySelectorAll('input[name="grout"]').forEach(grount => {
            grount.addEventListener('change', function () {

                if (this.value === "change") {
                    document.getElementById('coatingDepth').value = 3;
                    document.getElementById('coatingDepth').readOnly = true;
                    document.querySelector('.ps-change').style.display = "block";
                } else {
                    document.getElementById('coatingDepth').value = '';
                    document.getElementById('coatingDepth').readOnly = false;
                    document.querySelector('.ps-change').style.display = "none";
                }
            })
        });

        /* global calculoSelantesAdesivosParams */
        (function (window, document, undefined) {
            const $form = $("#groutCalculator");

            // Init vars
            let piecePerimeter,
                pieceArea,
                sectionArea,
                sectionAreaC,
                sectionAreaN,
                pieceVol,
                tubeYield,
                tubes = 0;
            let fv = {}; // fv == Fields Values
        
            if ($form) {
                $form.submit((e) => {
                    const fields = $form.serializeArray();
                    fv = {};
        
                    if (fields && Array.isArray(fields)) {
                        let productsTablet = [];
                        let productRough = [];
        
                        // Set field values
                        fields.map((field) => {
                            if (field.name.includes("productTablet")) {
                                field.name = "productsTablet";
                                productsTablet.push(field.value);
                                field.value = productsTablet;
                            }
        
                            if (field.name.includes("productRough")) {
                                field.name = "productsRough";
                                productRough.push(field.value);
                                field.value = productRough;
                            }
        
                            if (field.value && field.value !== "")
                                fv[field.name] = field.value;
                        });
        
                        //Calculating...
                        piecePerimeter = fv.coatingHeight * 2 + fv.coatingWidth * 2;
                        pieceArea = (fv.coatingHeight / 100) * (fv.coatingWidth / 100);
                        sectionAreaN = (fv.spacingWidth / 10) * ((fv.coatingDepth * 0.7) / 10);
                        sectionAreaC = (fv.spacingWidth / 10) * (3 / 10);
                        sectionArea = fv.grout == "change" ? sectionAreaC : sectionAreaN;
                        pieceVol = (piecePerimeter * sectionArea) / 1.5;
                        tubeYield = (400 / pieceVol) * pieceArea * (1 - fv.lossFactor / 100);
                        tubes = Math.ceil(fv.areaSize / tubeYield);
        
                        fv.tubes = tubes + " tubos";
        
                        $("#totalTablets").html("");
                        $(".quantidade_pastilhas").html("");
                        $("#totalRough").html("");
                        $(".quantidade_aspero").html("");
        
                        if (fv.type == "isTablet") {
                            $(".tablet-application").show();
                            $(".print-tablet").show();
                            fv.productsTablet.map((product) => {
                                const productSpl = product.split("-");
                                const productQtd = Math.ceil(
                                    fv.areaSize / productSpl[0]
                                );
        
                                $("#result-tablet").show();
        
                                $("#totalTablets").append(
                                    "<br/>" +
                                        "Quantidade necessária de " +
                                        productSpl[1] +
                                        ": " +
                                        "<strong>" +
                                        productQtd +
                                        " peças" +
                                        "</strong>"
                                );
        
                                $(".quantidade_pastilhas").append(
                                    "Quantidade necessária de " +
                                        productSpl[1] +
                                        ": " +
                                        "<strong>" +
                                        productQtd +
                                        " peças" +
                                        "</strong>" +
                                        "<br/>"
                                );
                            });
                        } else {
                            $(".tablet-application").hide();
                            $(".print-tablet").hide();
                        }
        
                        if (fv.type == "isRough") {
                            fv.productsRough.map((product) => {
                                $(".rough-application").show();
                                $(".print-rough").show();
                                const productSpl = product.split("-");
                                const potYield = (pieceArea * productSpl[0]) / 1;
                                // const productQtd = Math.ceil(fv.areaSize / potYield);
                                const productQtd = Math.ceil(fv.areaSize / 5.25);
        
                                $("#result-rough").show();
        
                                $("#totalRough").append(
                                    "<br/>" +
                                        "Quantidade necessária de " +
                                        productSpl[1] +
                                        ": " +
                                        "<strong>" +
                                        productQtd +
                                        " peças" +
                                        "</strong>"
                                );
        
                                $(".quantidade_aspero").append(
                                    "Quantidade necessária de " +
                                        productSpl[1] +
                                        ": " +
                                        "<strong>" +
                                        productQtd +
                                        " peças" +
                                        "</strong>" +
                                        "<br/>"
                                );
                            });
                        } else {
                            $(".rough-application").hide();
                            $(".print-rough").hide();
                        }
        
                        $("#result-block").show();
                        $("#totalGrout").html(fv.tubes);
                        $("#totalArea").html(fv.areaSize + " m²");
        
                        $(".largura_revestimento").html(fv.coatingWidth);
                        $(".comprimento_revestimento").html(fv.coatingHeight);
                        $(".espessura_revestimento").html(fv.coatingDepth);
                        $(".espaçamento_rejunte").html(fv.spacingWidth);
                        $(".quantidade_tubos").html(fv.tubes);
                        $(".metragem_ambiente").html(fv.areaSize + " m²");
                        
                        console.log(fv);

                        const data = {
                            action: "calculate_grout",
                            total: fv.tubes,
                            size: fv.areaSize + " m²",
                            email: fv.email,
                            grout:
                                fv.grout == "change" ? "Troca de rejunte" : "Piso novo",
                            height: fv.coatingHeight + " mm",
                            width: fv.coatingWidth + " mm",
                            depth: fv.coatingDepth + " mm",
                            spacing: fv.spacingWidth + " mm",
                            tabletProducts: $(".quantidade_pastilhas").html(),
                            roughProducts: $(".quantidade_aspero").html(),
                        };
        
                        $.ajax({
                            url: ajaxurl,
                            data: data,
                            type: "post",
                            success: function (response) {
                                console.log(response);
                            },
                        });
                    }
                    e.preventDefault();
                });
            }
        
            function solicitarOrcamento() {
                $(".box-solicitar-orcamento").fadeIn();
                $(".bg").fadeIn();
                $(".orcamento-produto").val("Rejunte Infinity");
                $(".orcamento-quantidade").val(fv.tubes);
                $(".orcamento-email").val(fv.email);
        
                return false;
            }
            $("#solicitarOrcamento").click(solicitarOrcamento);
        
            function imprimir() {
                $(".master-wrap .infos-top").hide();
        
                $(".master-wrap header").hide();
                $(".master-wrap .sidenav").hide();
                $(".master-wrap .topo.topo-small").hide();
                $(".master-wrap .bg-white").hide();
                $(".master-wrap footer").hide();
        
                $(".mostra-print").show();
        
                setTimeout(function () {
                    window.print();
                    $(".master-wrap .infos-top").show();
                    $(".master-wrap header").show();
                    $(".master-wrap .sidenav").show();
                    $(".master-wrap .topo.topo-small").show();
                    $(".master-wrap .bg-white").show();
                    $(".master-wrap footer").show();
                    $(".mostra-print").hide();
                }, 1000);
            }
            $("#imprimir").click(imprimir);

        }(window, document));
    }

}

export default CalcRejuntes;